import './ProgressField.style.less'

import { Input, Space } from 'antd'
import { useEffect, useState } from 'react'
import { EditFilled } from '@ant-design/icons'
import PercentageStatusDialog from './components/PercentageStatusDialog/PercentageStatusDialog'

interface Prop {
  current_progress: number
  onCurrentProgressChange: (percent: any) => void
  onSet: (value) => void
}
// '{"plan_date":1652166922,"current_progress":"22","comment_id":"de4dee9b-0c0c-4237-a988-cf1fee836921","created_at":1652166922,"created_by":"de4dee9b-0c0c-4237-a988-cf1fee836921"}'
export function ProgressField(prop: Prop) {
  const { current_progress, onCurrentProgressChange } = prop
  const [currentProgress, setcurrentProgress] = useState(0)
  const [errorMessage, seterrorMessage] = useState(null)

  useEffect(() => {
    setcurrentProgress(!isNaN(current_progress) ? current_progress : 0)
  }, [current_progress])

  const onKeyPress = (e) => {
    let keyCode = e.keyCode ? e.keyCode : e.which
    if (!(keyCode > 47 && keyCode < 58)) {
      e.preventDefault()
    }
  }
  const checkIfGreaterThanPreviousVal = (actualProgress) => {
    if (Number(actualProgress) <= Number(current_progress)) {
      seterrorMessage(
        `Value must be greater than previous value (${current_progress})%`
      )
      return false
    }
    seterrorMessage(null)
    return true
  }
  // Value must be greater than previous value (10)%
  const [isVisible, setisVisible] = useState(false)
  // <PBFPermission action="update" module="PBF_TASK">
  return (
    <div className="pbf-progress-field-container">
      <Input
        size="large"
        onKeyPress={onKeyPress}
        className="br-1 input-fat-1 input-right"
        suffix={
          <div>
            <Space direction="horizontal" size={10}>
              <span>%</span>
              <EditFilled onClick={() => setisVisible(true)} />
            </Space>
          </div>
        }
        onChange={(e) => {
          if (parseInt(e.target.value) > 100) {
            return
          }
          checkIfGreaterThanPreviousVal(parseInt(e.target.value))
          onCurrentProgressChange(
            !e.target.value ? 0 : parseInt(e.target.value)
          )
          setcurrentProgress(!e.target.value ? 0 : parseInt(e.target.value))
        }}
        value={currentProgress}
      />
      {errorMessage && (
        <div className="ant-form-item-explain ant-form-item-explain-error">
          <div role="alert">{errorMessage}</div>
        </div>
      )}
      {isVisible && (
        <PercentageStatusDialog
          visible={isVisible}
          onClose={() => {
            setisVisible(false)
          }}
          current_progress={current_progress}
          onSet={(value) => {
            prop.onSet(value)
            seterrorMessage(null)
          }}
        />
      )}
    </div>
  )
}
